// /settings/tokens (PRD §9.9, B6 PR2 / B6b).

import { createFileRoute } from '@tanstack/react-router';

import { TokensPage } from '../components/TokensPage';

export const Route = createFileRoute('/settings/tokens')({
  component: TokensRoute,
});

function TokensRoute(): React.JSX.Element {
  return <TokensPage />;
}
